"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _walletHistory = _interopRequireDefault(require("./wallet-history.store"));
var _bookings = _interopRequireDefault(require("./bookings.store"));
var _walletClaimPoints = _interopRequireDefault(require("./wallet-claim-points.store"));
var _cms = _interopRequireDefault(require("./cms.store"));
var _walletHistoryFactory = require("../factories/wallet-history.factory.js");
var _walletBalance = require("../factories/wallet-balance.factory");
var _user = _interopRequireDefault(require("./user.store"));
var _class;
/**
 * wallet page store
 */
let WalletPageStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function WalletPageStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, WalletPageStore);
    this.$env = $env;
    this.walletHistoryStore = new _walletHistory.default(initialState.walletHistoryStore, this.$env);
    this.bookingsStore = new _bookings.default(initialState.bookingsStore, this.$env);
    this.userStore = new _user.default(initialState.userStore);
    this.cmsStore = new _cms.default(initialState.userStore, this.$env);
    this.walletClaimPointsStore = new _walletClaimPoints.default(initialState.walletClaimPointsStore, this.$env);
  }

  /**
   * get balance
   * @returns {{}|{expiryDate: *, balanceAmount: string, expiryAmount: string}}
   */
  (0, _createClass2.default)(WalletPageStore, [{
    key: "balance",
    get: function () {
      const {
        formatPrice
      } = this.$env.currency;
      return (0, _walletBalance.walletBalanceFactory)(this.walletHistoryStore.history, formatPrice);
    }

    /**
     * get wallet history
     * @return {Array} history
     */
  }, {
    key: "walletHistory",
    get: function () {
      const {
        formatPrice
      } = this.$env.currency;
      return (0, _walletHistoryFactory.walletHistoryFactory)(this.walletHistoryStore.history, this.bookingsStore.orders, formatPrice);
    }

    /**
     *
     * @returns {boolean}
     */
  }, {
    key: "isRedeemed",
    get: function () {
      return (0, _get2.default)(this.walletHistoryStore.history, 'data.history.redeems', []).length > 0;
    }
  }]);
  return WalletPageStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "balance", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "balance"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "walletHistory", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "walletHistory"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isRedeemed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isRedeemed"), _class.prototype)), _class);
exports.default = WalletPageStore;